<template>
  <div>
    <div v-for="(info, ix) in route" :key="info.proType" class="van-hairline--top">
      <van-cell>
        <van-row type="flex" align="center">
          <van-col span="2" v-if="showDele">
            <ld-icon class="red" type="iconjianshao" @click="$emit('delete', ix, info.proType)"/>
          </van-col>
          <van-col :span="showDele ? 22 : 24">
            <van-row>
              <van-col span="16" class="font-lg font16">
                <ld-icon class="vertical-bottom main-color" size="24" :type="info.proType | icon"/>
                {{ info.departCityName || info.departAirportName }}
                <span v-show="info.arriveCityName || info.arriveAirportName">
                  - {{ info.arriveCityName || info.arriveAirportName }}
                </span>
              </van-col>
              <van-col span="8" class="text-right">
                <!-- <span class="red"><font class="font10">￥</font>{{ info.fyys }}</span> -->
                <van-badge v-if="info.spzt" :content="badge(info)"/>
              </van-col>
            </van-row>
            <div class="font12">
              <van-row>
                <van-col span="9">
                  <span v-show="info.proType==10903">{{ $t('ru', '入') }}：</span>
                  {{ info.departDate }}
                </van-col>
                <van-col span="12" class="van-ellipsis">
                  <div style="display: flex;justify-content: space-between;">
                    <span>{{ info.flightNo }}</span>
                    <span> 起飞时间&nbsp;{{ info.departTime }}</span>
                  </div>
                </van-col>
                <van-col span="3" class="text-right">
                  <span v-show="info.fjs">{{ info.fjs }}间</span>
                </van-col>
              </van-row>
              <div v-show="info.proType==10903">
                <span>离：</span>
                {{ info.arriveDate }}
              </div>
              <van-col span="12">
                {{ info.cxr }}
                <span v-if="info.spzt" style="color: #0d96e1" @click="ccsqdxcydmx(info)">预定明细</span>
              </van-col>
              <van-col span="12" class="text-right">
                <van-button v-if="info.spzt" type="default" size="small" @click="reserve(info);">
                  预 定
                </van-button>
              </van-col>
            </div>
          </van-col>
        </van-row>
      </van-cell>
    </div>

    <van-popup v-model="showPopup" style="width: 96%">
      <van-cell>
        <van-row v-for="psg in psgList" :key="psg.psgName">
          <van-col span="6">
            {{ psg.psgName }}
          </van-col>
          <van-col span="10">
            {{ psg.departTime }}
          </van-col>
          <van-col span="4">
            {{ psg.flightNo }}
          </van-col>
          <van-col span="4">
            {{ psg.cabin }}
          </van-col>
        </van-row>
      </van-cell>
    </van-popup>
  </div>
</template>
<script>
import {Cell, Button, Badge, Popup} from 'vant'
import orderMixin from '../../allorder/components/orderMixin'

export default {
  name: 'Route',
  mixins: [orderMixin],
  components: {
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Badge.name]: Badge,
    [Popup.name]: Popup,
  },
  props: {
    route: {
      type: Array,
      default: function () {
        return []
      }
    },
    showDele: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopup: false,
      psgList: [],
      hashAddr: ''
    }
  },
  created () {
    this.hashAddr = this.$route.path
  },
  methods: {
    // 预定
    reserve(o) {
      if ($dict.PRO_TYPE.tk === o.proType) {
        this.$router.push({
          path: "/tk/tkQuery",
          query: {
            ccsqdId: this.$route.query.ccsqdId, // 出差申请单ID
            routeId: o.routeId
          }
        });
      }
      if ($dict.PRO_TYPE.tr === o.proType) {
        this.$router.push({
          path: "/tr/trQuery",
          query: {
            ccsqdId: this.$route.query.ccsqdId,
            routeId: o.routeId
          }
        });
      }
      if ($dict.PRO_TYPE.hotel === o.proType) {
        this.$router.push({
          path: "/ht/htQuery",
          query: {
            ccsqdId: this.$route.query.ccsqdId,
            routeId: o.routeId
          }
        });
      }
      // 从出差申请单的行程计划里点击预订，预订方式为因公
      this.$store.commit('SET_TRIPTYPE', 1)
    },

    // 标记
    badge(o) {
      switch (o.proType) {
        case $dict.PRO_TYPE.tk:
          return '机票' + o.xh;
        case $dict.PRO_TYPE.tr:
          return '火车票' + o.xh;
        case $dict.PRO_TYPE.hotel:
          return '酒店' + o.xh;
      }
    },

    // 出差申请单行程预定明细
    ccsqdxcydmx(o) {
      this.showPopup = true;

      if ($dict.PRO_TYPE.tk === o.proType) {
        this.$api['common/ccsqdxcydmx']({
          routeId: o.routeId
        }).then(resp => {
          let data = resp.data || [];
          this.psgList = [];
          this.psgList.push({
            "psgName": "姓名",
            "departTime": "出发日期",
            "flightNo": "航班号",
            "cabin": "舱等"
          });
          data.forEach(o => {
            this.psgList.push(o);
          });
        });
      }

      if ($dict.PRO_TYPE.tr === o.proType) {
        this.$api['common/tr_ccsqdxcydmx']({
          routeId: o.routeId
        }).then(resp => {
          let data = resp.data || [];
          this.psgList = [];
          this.psgList.push({
            "psgName": "姓名",
            "departTime": "出发日期",
            "flightNo": "车次号",
            "cabin": "坐席"
          });
          data.forEach(o => {
            this.psgList.push(o);
          });
        });
      }

      if ($dict.PRO_TYPE.hotel === o.proType) {
        this.$api['common/ht_ccsqdxcydmx']({
          routeId: o.routeId
        }).then(resp => {
          let data = resp.data || [];
          this.psgList = [];
          this.psgList.push({
            "psgName": "姓名",
            "departTime": "入离日期",
            "flightNo": "酒店名",
            "cabin": "房型"
          });
          data.forEach(o => {
            this.psgList.push(o);
          });
        });
      }
    },
  }
}
</script>
<style lang="less" scoped>
.icon {
  margin-right: 5px;
  min-width: 1em;
  height: 24px;
  font-size: 16px;
}
</style>
